import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useLocales } from 'src/locales';

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

const ErrorScreen = () => {
  const { t } = useLocales();

  return (
    <Box
      sx={{
        margin: '0px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        bgcolor: 'background.default',
        color: 'text.primary',
        textAlign: 'center',
        p: 3,
      }}
    >
      {/* <ErrorOutlineIcon sx={{ fontSize: 60, mb: 2 }} /> */}
      <Typography variant="h4" gutterBottom>
        {t('error_boundary.title')}
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        {t('error_boundary.description')}
      </Typography>
      <Button variant="contained" color="primary" onClick={() => window.open('/', '_self')}>
        {t('error_boundary.refresh_button')}
      </Button>
    </Box>
  );
};


class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("Error Boundary caught an error", error, errorInfo);
  }


  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return <ErrorScreen />;
    }

    return children;
  }
}

export default ErrorBoundary;
